import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-paginator',
    templateUrl: './paginator.component.html',
    styleUrls: ['./paginator.component.css']
})
export class PaginatorComponent implements OnInit {

    @Input() config: { endRow: number, page: string, rows: number, startRow: number, totalPages: number, totalRows: number } | undefined;

    @Output() prev: EventEmitter<any> = new EventEmitter();
    @Output() next: EventEmitter<any> = new EventEmitter();
    @Output() refresh: EventEmitter<any> = new EventEmitter();
    @Output() setPage: EventEmitter<number> = new EventEmitter<number>();

    constructor() { }

    ngOnInit(): void {
    }

    onValueChange() {
        let maxPage = 1;
        let currentPage = 1;

        if (this.config?.page != undefined) {
            currentPage = parseInt(this.config?.page);
        }
        if (this.config?.totalPages != undefined) {
            maxPage = this.config?.totalPages;
        }

        if (currentPage == null) {
            currentPage = 1;
        } else if (currentPage > maxPage) {
            currentPage = maxPage;
        }

        this.setPage.emit(currentPage);
    }

    getTooltip(item: string) {
        let msg = '';

        switch (item) {
            case "currentPage":
                msg = 'Premi invio per confermare';
                break;
        }

        return msg;
    }
}
